/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ComponentGridFilter, ItemRestService, ItemsGridFilter } from '@gh/builder-shared-data';
import { getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { getRouteTrackerFilter, SlicedDataSource } from '@gh/core-data';
import { getSlicedDataQueryFromCursorTracker, GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { DEFAULT_ITEM_FILTER, ItemsListCheckUsage, ItemsListItem } from './items-list-item.model';

@Injectable()
export class ItemsListBusinessService implements InitViewService {

  constructor(private itemsRest: ItemRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(snapshot: ActivatedRouteSnapshot): any {
    const itemId = getRouteQueryParam(snapshot, 'focusedId');
    const filter = getRouteTrackerFilter<ComponentGridFilter>(snapshot) || DEFAULT_ITEM_FILTER;
    const { sorting } = getSlicedDataQueryFromCursorTracker(snapshot);
    return {
      gridLayout: this.gridLayoutService.get('items'),
      itemIndex: itemId && this.itemsRest.getIndex(itemId, filter, sorting),
    };
  }

  findAllAsDataSource(filter: ItemsGridFilter): SlicedDataSource<ItemsListItem> {
    return this.itemsRest.findAllAsDataSource(filter);
  }

  activate(item: ItemsListItem): Observable<ItemsListItem> {
    return this.itemsRest.undelete(item);
  }

  checkUsage(item: ItemsListItem): Observable<ItemsListCheckUsage> {
    return this.itemsRest.checkUsage(item);
  }

  deactivateOrDelete(item: ItemsListItem, checkUsage: ItemsListCheckUsage): Observable<any> {
    return this.itemsRest.deactivateOrDelete(item, checkUsage);
  }

  bulkDelete(items: any[]): Observable<any> {
    return this.itemsRest.bulkDelete(items);
  }
}
